import React, { Component, Suspense } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux"

import { Grid, Typography, Collapse, Snackbar } from "@material-ui/core";
import Alert from "@material-ui/lab/Alert";

import * as PaymentActions from "../actions/PaymentActions";

import SignInForm from '../components/SignInForm';
import PaymentForm from '../components/PaymentForm/PaymentForm';
import ResetPasswordForm from '../components/ResetPasswordForm';

const SNACKBAR_INIT_VALUE = {
  open: false,
  type: "error",
  message: "",
  duration: 6000,
};

class Body extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isSignIn: false,
      isForgotPass: false,
      snackbar: SNACKBAR_INIT_VALUE,
    };

    this.toggleSignInForm = this.toggleSignInForm.bind(this);
    this.toggleForgotPass = this.toggleForgotPass.bind(this);
    this.handleSnackbarClose = this.handleSnackbarClose.bind(this);
  }

  componentDidUpdate = (prevProps, prevState) => {
    const { isSignIn } = this.state;
    const { isSignIn: prevIsSignIn } = prevState;

    if(prevIsSignIn !== isSignIn) this.props.actions.togglePrimaryColor();

  }

  handleSnackbarClose = () => this.setState({ snackbar: SNACKBAR_INIT_VALUE });

  handleSnackbarOpen = (snackbar) => {
    if(snackbar === null) return this.handleSnackbarClose();
    else this.setState({ snackbar });
  }

  toggleSignInForm = () => !this.props.loading ? this.setState({ isSignIn: !this.state.isSignIn }) : null;

  toggleForgotPass = () => !this.props.loading ? this.setState({ isForgotPass: !this.state.isForgotPass }) : null;


  render = () => {
    const { state, toggleSignInForm, toggleForgotPass, handleSnackbarClose, handleSnackbarOpen: openSnackbar } = this;
    let { isSignIn, isForgotPass, snackbar } = state;

    return (
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Suspense fallback={<Typography variant="h4">Loading...</Typography>}>
            <Collapse in={isSignIn && !isForgotPass}>
              <SignInForm lazy {...{ toggleSignInForm, toggleForgotPass }} />
            </Collapse>
            <Collapse in={!isSignIn && !isForgotPass}>
              <PaymentForm lazy {...{ toggleSignInForm, openSnackbar }} />
            </Collapse>
            <Collapse in={isForgotPass}>
              <ResetPasswordForm toggleForgotPass={toggleForgotPass} />
            </Collapse>
          </Suspense>
        </Grid>
        <Snackbar
          open={snackbar.open}
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
          autoHideDuration={snackbar.duration || 6000}
          onClose={handleSnackbarClose}
        >
          <Alert onClose={handleSnackbarClose} severity={snackbar.type} variant="filled"><Typography variant="body2">{snackbar.message}</Typography></Alert>
        </Snackbar>
      </Grid>
    );
  };
}

Body.propTypes = {};

const mapStateToProps = ({ payment }) => ({
  loading: payment.loading,
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(PaymentActions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(Body);
